<div class="content">
    <div class="step-header">
        <div class="title">Site location</div>
    </div>
    <div class="content md-margin-top">
        <location-settings [parentOutput]="step.output" [parent]="'sites'" [step]="step" [config]="step.config"
            class="locationContainer" [dataSource]="step.dataSourceObservable" [key]="'point'"
            [defaultLocation]="step.output">
        </location-settings>
    </div>
</div>